import { getCertificationStateSubtitle, getRemunerationTitle } from '../../misc/textHelper';
import { GroupDialogResult } from '../groupDialog/GroupDialogResult';
import './simpleRemuneration.less';

/**
 * @typedef { import('./SimpleGroupModel').SimpleGroupModel } SimpleGroupModel
 * @typedef { import('../PaymentLock').PaymentLock } PaymentLock
 * @typedef { import('../../objects/Claim').Claim } Claim
 * @typedef { import('../../server/ApiServer').ApiServer } ApiServer
 */

/**
 * @param {SimpleGroupModel} pg
 */
function getSubTitle(pg) {
    if (pg.hasCompleted && pg.hasClaim && pg.payments.length === 0) {
        return 'godkänt anspråk utan arvoden';
    }

    if (pg.remuneration != null) {
        return getCertificationStateSubtitle(pg.remuneration.CertificationState);
    }
}

class SimpleRemunerationController {
    static $inject = ['dialogService'];
    /**
     * @param {any} dialogService
     */
    constructor(dialogService) {
        this._dialogService = dialogService;
        /** @type {SimpleGroupModel} */
        this.paymentGroup = null;
    }

    $onChanges(changed) {
        if (changed.paymentGroup) {
            if (this.paymentGroup != null) {
                let maintitle = getRemunerationTitle(this.paymentGroup.remunerationType, this.paymentGroup.claim?.ClaimType);
                let subtitle = getSubTitle(this.paymentGroup);
                this.title = subtitle ? `${maintitle} (${subtitle})` : maintitle;
            } else {
                this.title = null;
            }
        }
    }

    showDetail() {
        if (this.paymentGroup && this.paymentGroup.hasDetail) {
            this._dialogService.showPaymentGroup(this.paymentGroup).then(result => {
                if (result instanceof GroupDialogResult) {
                    result.apply(this.paymentGroup);
                }
            });
        }
    }
}

angular.module("tromanWeb").component('ergoSimpleRemuneration', {
    template: require('./simpleRemuneration.html'),
    bindings: {
        paymentGroup: '<',
        paymentLock: '<',
        wageTypes: '<',
    },
    controller: SimpleRemunerationController,
});
